/* ⚛ REACT */
import React, { useRef, useEffect } from "react";

/* 📦 LIBS */
import { useMediaQuery } from "@react-hook/media-query";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 🎨 STYLES */
import { PopupContainer } from "./styles";

const Popup = (props) => {
    let childs = React.Children.toArray(props.children);
    let active = useSelector(state => state.PopupReducer.name) === props.name;

    const isSmallScreen = useMediaQuery("(max-width: 1080px)");
    const isMediumScreen = useMediaQuery("(max-width: 1400px)");

    const popupRef = useRef(null);
    
    useEffect(() => {
        if (props.buttonRef.current && popupRef.current && !isSmallScreen) {
            const buttonRect = props.buttonRef.current.getBoundingClientRect();
            const popoverWidth = popupRef.current.offsetWidth; 
            if (isMediumScreen) {
                popupRef.current.style.top = `${buttonRect.bottom + window.scrollY + 6}px`;
                popupRef.current.style.left = `${buttonRect.left + window.scrollX - popoverWidth - 5}px`;
            } else {
                popupRef.current.style.top = `${buttonRect.bottom + window.scrollY + 2}px`;
                popupRef.current.style.left = `${buttonRect.left + window.scrollX + 34}px`; 
            }
        }
    });

    return(
        <PopupContainer $Active={active}>
            <div className="content" id={props.id} ref={popupRef}>
                <h2>{props.title}</h2>
                <div className='childs-container'>
                    {childs.map(child=>(
                        child
                    ))}
                </div>
            </div> 
        </PopupContainer>
    )
};

export default Popup;